/*
 * Facebox (for jQuery)
 * version: 1.3
 * @requires jQuery v1.2 or later
 * @homepage https://github.com/defunkt/facebox
 *
 * Licensed under the MIT:
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * Copyright Forever Chris Wanstrath, Kyle Neath
 *
 * Usage:
 *
 *  jQuery(document).ready(function() {
 *    jQuery('a[rel*=facebox]').facebox()
 *  })
 *
 *  <a href="#terms" rel="facebox">Terms</a>
 *    Loads the #terms div in the box
 *
 *  <a href="terms.html" rel="facebox">Terms</a>
 *    Loads the terms.html page in the box
 *
 *  <a href="terms.png" rel="facebox">Terms</a>
 *    Loads the terms.png image in the box
 *
 *
 *  You can also use it programmatically:
 *
 *    jQuery.facebox('some html')
 *    jQuery.facebox('some html', 'my-groovy-style')
 *
 *  The above will open a facebox with "some html" as the content.
 *
 *    jQuery.facebox(function($) {
 *      $.get('blah.html', function(data) { $.facebox(data) })
 *    })
 *
 *  The above will show a loading screen before the passed function is called,
 *  allowing for a better ajaxy experience.
 *
 *  The facebox function can also display an ajax page, an image, or the contents of a div:
 *
 *    jQuery.facebox({ ajax: 'remote.html' })
 *    jQuery.facebox({ ajax: 'remote.html' }, 'my-groovy-style')
 *    jQuery.facebox({ image: 'stairs.jpg' })
 *    jQuery.facebox({ image: 'stairs.jpg' }, 'my-groovy-style')
 *    jQuery.facebox({ div: '#box' })
 *    jQuery.facebox({ div: '#box' }, 'my-groovy-style')
 *
 *  Want to close the facebox?  Trigger the 'close.facebox' document event:
 *
 *    jQuery(document).trigger('close.facebox')
 *
 *  Facebox also has a bunch of other hooks:
 *
 *    loading.facebox
 *    beforeReveal.facebox
 *    reveal.facebox (aliased as 'afterReveal.facebox')
 *    init.facebox
 *    afterClose.facebox
 *
 *  Simply bind a function to any of these hooks:
 *
 *   $(document).bind('reveal.facebox', function() { ...stuff to do after the facebox and contents are revealed... })
 *
 */
(function($) {

  var isOpen = false;
  var $loading = null;

  $.facebox = function(data, options, id) {
    if ( !options ) options = {};
    $.facebox.loading()
    $.facebox.reveal(data, options, id)
  }

  /*
   * Public, $.facebox methods
   */

  $.extend($.facebox, {
    settings: {
      opacity      : 0.2,
      overlay      : true,
      loadingImage : '/facebox/loading.gif',
      closeImage   : '/facebox/closelabel.png',
      imageTypes   : [ 'png', 'jpg', 'jpeg', 'gif', 'bmp' ],
      faceboxHtml  : '\
    <a href="#" class="close facebox-close"></a> \
    <div id="facebox" class="facebox" style="display:none;"> \
      <div class="popup"> \
        <div class="content" style="display: none;"></div> \
      </div> \
      <div class="loading" style="z-index: 12; display none;"><div class="message"></div><div class="wrapper"><div class="loader"></div></div></div>\
    </div> \
    <div id="subfacebox" class="facebox" style="display:none;"></div> \
    <div id="facetip" style="display:none;"><div class="content"></div></div>'
    },

    loading: function(message) {
      init()
      var jq = $('#facebox');
      if(! $loading ) {
        $loading = jq.find('.loading');
      }
      if ( jq.find('.keep').is(':visible') ) jq = $('#subfacebox');
      if ( jq.find('.loading').is(':visible') ) return true;

      $loading.fadeIn(100);
      // NOTICE: we cannot remove content because it may contain a form that has not been submitted yet
      // test with photo uploads
      //jq.find('.content').css('width', 'auto').children().hide().end().
      //  append('<div class="loading">'+(message || '<img class="facebox-loading-image" src="'+$.facebox.settings.loadingImage+'"/>')+'</div>')

      jq.show().css({
        top:	getPageScroll()[1] + (70) + (jq.attr('id') == 'subfacebox' ? 50 : 0),
        left:	0 // leftOffset(jq)
      })

      $(document).bind('keydown.facebox', function(e) {
        if (e.keyCode == 27) $.facebox.close()
        return true
      })
      $(document).trigger('loading.facebox')
    },

    reveal: function(data, options, id) {
      $loading.fadeOut(100);
      id = id || '#facebox';
      var jq = $(id);
      var $content = jq.find('.popup > .content');
      options = options || {};
      if ( id == '#facebox' && $('#subfacebox').is(':visible') ) $.facebox.close();
      if (options.error) jq.find('.popup').addClass('error')
      // insert a div wrapper so we can fade it and hide it in loading()
      var $old_wrapper = $content.children('div').first();
      var $new_wrapper = $('<div />')
      $new_wrapper.addClass('facebox-content-wrapper');
      if($old_wrapper.size()) {
        $old_wrapper.css({'z-index': '11'});
        var offset = $old_wrapper.offset();
        $new_wrapper.css({'position': 'absolute', 'top': '0', 'left' : offset.left, 'width': offset.width, 'z-index': '10'});
      }
      $content.append($new_wrapper);
      if (options.klass) $new_wrapper.addClass(options.klass)

      $new_wrapper.html(data);

      var setWidthAndReveal = function(width){
        jq.css('left', 0);

        if($content.is(':visible')) {
          $old_wrapper.fadeTo(500, 0, function () {
            $(this).remove();
            $new_wrapper.css({'position': 'relative', 'left': 0, width: '100%'});
          });
        }
        else {
          $new_wrapper.css({'position': 'relative', 'left': 0, width: '100%'});
          $old_wrapper.remove();
          $content.fadeTo(200, 1);
        }

        isOpen = true;
        $('.facebox-close').show();
        $(document).trigger('afterReveal.facebox');
      };

      var width = '32em';
      if ( $new_wrapper.find('.image').size() > 0 ) {
        jq.css('right', '30px');
        jq.css('left', '30px');
        width = '100%';
      } else {
        jq.css('right', 'auto');
        jq.css('left', 'auto');
      }

      if ( $new_wrapper.find('.login-container, .wide, .post, .wide_fields, .qr, .w30em, .w35em, .w37em, .add_many, #topo_editor, .text').size() > 0 ) {
        width = 'auto';
      }

      setWidthAndReveal(width);
      app.bindDatePicker($new_wrapper);
    },

    close: function() {
      $(document).trigger('close.facebox')
      return false
    },

    // Figures out what you want to display and displays it
    // formats are:
    //     div: #id
    //   image: blah.extension
    //    ajax: anything else
    fillFaceboxFromHref: function (href, options, that) {
      // div
      if (href.match(/#/)) {
        var url    = window.location.href.split('#')[0]
        var target = href.replace(url,'')
        if (target == '#') return
        $.facebox.reveal($(target).html(), options)
        // image
      } else if ( href.match(/photos\/[0-9]*$/) ) {
        if( typeof options.klass == 'undefined')
          options.klass = '';
        options.klass += ' facebox-content-nopadding';
        $.facebox.revealPhoto(href, options, that);
        //$.facebox.get(href, options, id);
      } else if (href.match($.facebox.settings.imageTypesRegexp)) {
        if( typeof options.klass == 'undefined')
          options.klass = '';
        options.klass += ' facebox-content-nopadding';
        $.facebox.revealPhoto(href, options, that);
        //fillFaceboxFromImage(href, options, that);
        // ajax
      } else {
        var id = (that.rel.match(/subfacebox/) ? '#subfacebox' : '#facebox');
        $.facebox.get(href, options, id);
      }
    }
  });



  /*
   * Public, $.fn methods
   */

  $.fn.facebox = function(settings, before_loading) {
    // always initialize and activate live handler
    // if ($(this).length == 0) return

    init(settings)

    function clickHandler() {
      if ( before_loading ) before_loading();
      $.facebox.loading()
      var options = {klass: ''}

      $.facebox.fillFaceboxFromHref(this.href, options, this)
      return false
    }

    $(document).on('click.facebox', this.selector, clickHandler);
    return this
  }

  /*
   * Private methods
   */

  // called one time to setup facebox on this page
  function init(settings) {
    if ($.facebox.settings.inited) return true
    else $.facebox.settings.inited = true

    $(document).trigger('init.facebox')

    var imageTypes = $.facebox.settings.imageTypes.join('|')
    $.facebox.settings.imageTypesRegexp = new RegExp('\\.(' + imageTypes + ')(\\?.*)?$', 'i')

    if (settings) $.extend($.facebox.settings, settings)
    $('body').append($.facebox.settings.faceboxHtml)
    // clone popup for subfacebox and tooltips
    $('#facebox .popup').clone().appendTo('#subfacebox')

    var preload = new Image();
    preload.src = $.facebox.settings.loadingImage

    $(document).on('click', '.facebox-close, #subfacebox .close', $.facebox.close);
    // $('#facebox .close, #subfacebox .close').append('<img src="' + $.facebox.settings.closeImage + '" class="close_image" title="close">')
  }

  // getPageScroll() by quirksmode.com
  function getPageScroll() {
    var xScroll, yScroll;
    if (self.pageYOffset) {
      yScroll = self.pageYOffset;
      xScroll = self.pageXOffset;
    } else if (document.documentElement && document.documentElement.scrollTop) {	 // Explorer 6 Strict
      yScroll = document.documentElement.scrollTop;
      xScroll = document.documentElement.scrollLeft;
    } else if (document.body) {// all other Explorers
      yScroll = document.body.scrollTop;
      xScroll = document.body.scrollLeft;
    }
    return new Array(xScroll,yScroll)
  }

  // Adapted from getPageSize() by quirksmode.com
  function getPageHeight() {
    var windowHeight
    if (self.innerHeight) {	// all except Explorer
      windowHeight = self.innerHeight;
    } else if (document.documentElement && document.documentElement.clientHeight) { // Explorer 6 Strict Mode
      windowHeight = document.documentElement.clientHeight;
    } else if (document.body) { // other Explorers
      windowHeight = document.body.clientHeight;
    }
    return windowHeight
  }

  function fillFaceboxFromImage(href, options, that) {
    var image = new Image()
    image.onload = function() {
      $.facebox.revealImage(image, options, that)
    };
    image.src = href
  }

  function leftOffset($elem) {
    //console.log($elem.outerWidth());
    var off = $(window).width() / 2 - ($elem.outerWidth() / 2);
    return (off < 10 ? 10 : off);
  }


  /*
   * Bindings
   */

  $(document).bind('close.facebox', function() {
    var sub = $('#subfacebox')
    if ( sub.is(':visible') ) {
      var jq = sub
    } else {
      var jq = $('#facebox')
      $(document).unbind('keydown.facebox')
      isOpen = false;
    }
    $('.facebox-close').hide();
    jq.find('.popup.error').removeClass('error')
    jq.fadeOut(function() {
      jq.find('.content').hide();//removeClass().addClass('content')
      $(document).trigger('afterClose.facebox')
    })
  })

})(jQuery);
